<template>
  <section class="py-4">
    <div class="container">
      <div class="mb-4">
        <img
          :src="getFileViewUrl(poster.pic)"
          alt
          class="img-fluid lazyload w-100"
        />
      </div>
      <div class="row">
        <div class="col-xl-8 mx-auto">
          <div class="bg-white rounded shadow-sm p-4">
            <div class="border-bottom">
              <h1 class="h4">
                {{ poster.title }}
              </h1>
            </div>
            <div class="mb-4 overflow-hidden" v-html="poster.content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { getDetail } from "@/api/poster";

export default {
  data() {
    return { poster: {} };
  },
  methods: {
    async getPoster() {
      const res = await getDetail(this.$route.query.code);
      this.poster = res.data;
    }
  },
  watch: {
    $route: {
      handler() {
        this.getPoster();
      }
    }
  },
  created() {
    this.getPoster();
  }
};
</script>
